import CollapsibleArea from './CollapsibleArea';

export default CollapsibleArea;
